import React from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import TitlePage from 'components/TituloPage';
import { postosAtendimentoListar } from 'routes/paths';
import FormularioPostosAtendimento from 'containers/Forms/FormPostosAtendimento/index';
import { formatterPostosAtendimentoBackToFront } from 'utils/formatter/postosAtendimento';
import { montarDadosInputSelect } from 'utils/funcaoPadrao';
import * as S from '../styles';
import * as Style from 'components/Style';

export default function PostosAtendimentoDetalhar() {
  const postoAtendimentoDetalhar = useSelector(state => state.postosAtendimento.postosAtendimentoDetalhar);

  const {
    control,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: formatterPostosAtendimentoBackToFront(postoAtendimentoDetalhar),
  });

  return (
    <S.Page>
      <TitlePage textTitle={'VISUALIZAR POSTO DE ATENDIMENTO'} backPage={postosAtendimentoListar} />
      <Style.GlobalCard>
        <FormularioPostosAtendimento
          errors={errors}
          getValues={getValues}
          control={control}
          setValue={setValue}
          setError={setError}
          optionsServicos={montarDadosInputSelect(
            postoAtendimentoDetalhar.postoSolicitacoes,
            'solicitacaoId',
            'solicitacao'
          )}
          onSubmit={() => {}}
          disabled={true}
        />
      </Style.GlobalCard>
    </S.Page>
  );
}
